import env from 'env'

export const loadScript = () => {
  window.utag_cfg_ovrd = { noview : true }
  window.utag_data = {}
  const url = `https://tags.tiqcdn.com/utag/${env.analytics.account}/${env.analytics.profile}/${env.analytics.environment}/utag.js`

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = url
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}
